import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Send, Plus, Globe } from "lucide-react";

import SpatialInput from "./SpatialInput";
import WaitlistModal from "./WaitlistModal";

// --- MAIN COMPONENT ---

const HeroSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [videoStarted, setVideoStarted] = useState(false);

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (videoRef.current.readyState >= 3 || !videoRef.current.paused) {
        setVideoStarted(true);
      }
    }
  }, []);

  return (
    <section className="relative w-full h-[100dvh] max-h-[100dvh] bg-white flex flex-col items-center pt-20 md:pt-28 overflow-hidden selection:bg-[#0055FF] selection:text-white">

      {/* --- EMAIL MODAL (Shared Swiss Design) --- */}
      <WaitlistModal open={isModalOpen} setOpen={setIsModalOpen} prompt={prompt} />

      <div className="relative z-10 w-full h-full max-w-[1080px] px-6 flex flex-col items-center justify-center text-center pb-8">

        {/* HERO ANIMATION VIDEO - FLEXIBLE HEIGHT */}
        <div className="w-full flex-1 min-h-0 flex items-center justify-center max-w-[1000px] pointer-events-none select-none">
          <h1 className="sr-only">Monet - Spatial Event Planning</h1>
          <video
            ref={videoRef}
            src="/assets/Hero_ani.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            onPlaying={() => setVideoStarted(true)}
            className="w-full h-full max-h-[50vh] object-contain"
            style={{
              maskImage: "linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%), linear-gradient(to bottom, black 80%, transparent 100%)",
              WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%), linear-gradient(to bottom, black 80%, transparent 100%)",
              maskComposite: "intersect",
              WebkitMaskComposite: "source-in"
            }}
          />
        </div>

        {/* --- INPUT INTERFACE (NOW THE HERO) --- */}
        <SpatialInput
          className="my-6 md:my-10 shrink-0"
          shouldAnimate={videoStarted}
          videoRef={videoRef}
          onSubmit={(value) => {
            setPrompt(value);
            setTimeout(() => setIsModalOpen(true), 150)
          }}
        />

        {/* H2 IS NOW BELOW THE PROMPT */}
        <h2 className="font-sans text-[20px] md:text-[27px] leading-[1.4] mb-8 text-[#111111]/60 max-w-[800px] font-bold shrink-0">
          You shouldn’t have to battle for 3 months  <br />to get a concept approved.
        </h2>

      </div>
    </section>
  );
};

export default HeroSection;